import React from 'react'
import Loader from './Loader'

export default function FullPageLoader() {
    return (
        <section className='full-page-loader'>
            <img src="/assets/logo.png" alt="Doha Drug Store Logo" data-aos="fade-down" />
            <Loader />
        </section>
    )
}
